import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  earlyPayoutConfigurations: null,
};

const earlyPayoutSettingsSlice = createSlice({
  name: 'earlyPayoutSettings',
  initialState,
  reducers: {
    aGetEarlyPayoutSettingsSuccess: (state, action) => {
      state.earlyPayoutConfigurations = action.payload.earlyPayoutConfigurations;
    },
    aUpdateEarlyPayoutSettings: () => {
    },
    aUpdateEarlyPayoutSettingsSuccess: (state, action) => {
      state.earlyPayoutConfigurations = action.payload.earlyPayoutConfigurations;
    },
  },
});

export const {
  aGetEarlyPayoutSettingsSuccess,
  aUpdateEarlyPayoutSettings,
  aUpdateEarlyPayoutSettingsSuccess
} = earlyPayoutSettingsSlice.actions;

export default earlyPayoutSettingsSlice.reducer;
